import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

export const Wrapper = styled.div`
  @media (${mediaQuery.tablet}) {
    margin-top: 26px;
    padding: 0 32px;
    display: ${(props) => (props.isOnHomepage ? 'block' : 'none')};
  }
  ${media.xs`
    margin-top:24px;
    padding: 0 16px;
  `};
`;
